/**
 * "Notify me of a reply" watches (backend EmailReplyWatchController,
 * v2/email-reply-watches). Sending with notifyOnReply (thread composer,
 * mails/send) creates them too; here a thread is watched without sending
 * (the bell of an inbox item), looked up and stopped.
 */
define('entities/email_reply_watches',[
  'app',
  'jquery',
  'underscore',
  'settings'
], function (
  App,
  $,
  _,
  Settings
) {
  'use strict';

  function ajax(type, path, params, body) {
    var defer = $.Deferred();
    $.ajax({
      type: type,
      url: Settings.url('compuzz2', 'v2/email-reply-watches' + (path || ''), params),
      data: body ? JSON.stringify(body) : undefined,
      processData: false,
      contentType: 'application/json',
      success: function (response) {
        defer.resolve(response || null);
      },
      error: function () {
        defer.reject();
      }
    });
    return defer.promise();
  }

  var API = {
    // My WAITING watches (status: 'ALL' for every status).
    list: function (status) {
      return ajax('GET', '', status ? {status: status} : null);
    },

    // query: {salesInboxItemSecId} or {emailAddressSecId, threadId}.
    // Resolves the watch, or null when there is none.
    find: function (query) {
      return ajax('GET', '/find', query);
    },

    // body: {salesInboxItemSecId} or {emailAddressSecId, threadId, subject}.
    watch: function (body) {
      return ajax('POST', '', null, body);
    },

    cancel: function (secId) {
      return ajax('DELETE', '/' + secId);
    },

    // After a send with notifyOnReply: the backend answers replyWatch=false
    // when it could not watch the thread (e.g. an SMTP mailbox). The mail is
    // sent anyway, so this is only a warning.
    warn: function (asked, response) {
      if (!asked || !response || response.replyWatch !== false || !$.notify) return;
      $.notify({
        message: _.i18n('emails.notifyOnReply.failed', null,
          'The mail is sent, but you will not be notified of the reply.')
      }, {
        type: 'warning',
        placement: {from: 'top', align: 'center'},
        delay: 5000
      });
    }
  };

  App.reqres.setHandler('emailReplyWatches:list', function (status) {
    return API.list(status);
  });
  App.reqres.setHandler('emailReplyWatches:find', function (query) {
    return API.find(query);
  });
  App.reqres.setHandler('emailReplyWatches:watch', function (body) {
    return API.watch(body);
  });
  App.reqres.setHandler('emailReplyWatches:cancel', function (secId) {
    return API.cancel(secId);
  });
  App.reqres.setHandler('emailReplyWatches:warn', function (asked, response) {
    return API.warn(asked, response);
  });
});

